import { render } from "./DonorDeferralsTab.vue?vue&type=template&id=3d2563f1"
import script from "./DonorDeferralsTab.vue?vue&type=script&lang=js"
export * from "./DonorDeferralsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__